import autobind from 'autobind-decorator';
import * as React from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';
import {Alert, Button, DatePicker, Empty, Icon, Row, Select, Spin} from 'antd';
import {connect} from 'redux-scaffolding-ts';
import {EmployeeSummary, ReportEmployeesStore} from 'src/stores/employees-store';
import {Query} from 'src/core/stores/dataStore';
import FileSaver from 'file-saver';
import 'react-splitter-layout/lib/index.css';
import {formatMessage} from 'src/core/services/http.service';
import EmployeeReportChart, {GetColors} from '../../../components/employees-report-chart';
import EmployeeReportTable from '../../../components/employees-report-table';
import moment from 'moment-timezone';
import {Moment} from 'moment';
import {EmployeesReport, EmployeesReportStore} from '../../../stores/employee-report-store';
import {FormComponentProps} from 'antd/lib/form';
import Form, {GetFieldDecoratorOptions} from 'antd/lib/form/Form';
import FormItem from 'antd/lib/form/FormItem';
import {nameof} from '../../../core/utils/object';
import '../../../assets/custom.scss'
import { successNotification } from '../../../components/systemNotifications/notificationService';

const { Option } = Select;
const { RangePicker } = DatePicker



interface EmployeesReportViewState {
    error?: string;
    employeesQuery: Query;
    timesheetsQuery: Query;
    isBusy: boolean;
    isPlotting: boolean;
    employees: EmployeeSummary[];
    employeesIndex: Map<string, number>;
    selectedEmployees: number[];
    employeesReport?: EmployeesReport;
    dataColors: string[];
    lineColors: string[];
    fromDateStamp: number;
    toDateStamp: number;
    chartRenderToggle: boolean;
}

interface EmployeeReportRequest {
    employees: EmployeeSummary[];
    fromDateStamp: number;
    toDateStamp: number;
    from: Moment,
    to: Moment
}

interface ClassFormBodyProps extends WithTranslation {
    item: EmployeeReportRequest | undefined
    onSave?: () => Promise<any>
    getFieldDecorator<T extends Object = {}>(id: keyof T, options?: GetFieldDecoratorOptions): (node: React.ReactNode) => React.ReactNode
    getFieldValue: (name: string) => any
    validateFields: (fieldNames?: string[], options?: any, callback?: any) => void
    isAdmin: boolean,
    isManager: boolean;
}


class ReportFormBody extends React.Component<ClassFormBodyProps> {
    constructor(props: ClassFormBodyProps) {
        super(props);
        this.state = {
        }
    }

    @autobind
    private async validateEmployees(rule: any, value: any) {
        const { t } = this.props;
        if (value == undefined || (value as any[]).length == 0) {
            throw new Error(t("At least one employee must be selected"))
        }
    }



    @autobind
    private validateDatePickerEnd(rule: any, date: Moment, callback: any) {
        var startDate = this.props.getFieldValue(nameof<EmployeeReportRequest>('from'))
        var endDate = this.props.getFieldValue(nameof<EmployeeReportRequest>('to'))
        if (startDate.isBefore(endDate)) {
            this.props.validateFields([nameof<EmployeeReportRequest>('from')], { force: true })

            callback();
        } else {
            const { t } = this.props;
            callback(t('The final date must be greater than or equal to the initial date'));
        }

    }

    @autobind
    private validateDatePickerStart(rule: any, date: Moment, callback: any) {
        var startDate = this.props.getFieldValue(nameof<EmployeeReportRequest>('from'))
        var endDate = this.props.getFieldValue(nameof<EmployeeReportRequest>('to'))
        if (startDate.isBefore(endDate)) {
            this.props.validateFields([nameof<EmployeeReportRequest>('to')], { force: true })
            callback();
        } else {
            const { t } = this.props;
            callback(t('The final date must be greater than or equal to the initial date'));
        }

    }


    render() {
        const { t, isAdmin, isManager } = this.props;
        var item = this.props.item || {} as EmployeeReportRequest;
        return <Form
            layout="inline"
            id="modaForm">
            {(isAdmin || isManager) && <FormItem className={"custom-form-item-message"} style={{ minWidth: 300, maxWidth: 300 }}>
                <div data-tut="reactour__navegateReport1">
                    {this.props.getFieldDecorator(nameof<EmployeeReportRequest>('employees'), {
                        rules: [{ required: false, message: t('Employees must be specified') }, { validator: this.validateEmployees }],
                    })(
                        <Select
                            mode="multiple"
                            className={"custom-select-multiple"}
                            style={{ minWidth: 300, maxWidth: 300 }}
                            placeholder={t('Employees')}
                            filterOption={(input, option) => {
                                if (option.props.children)
                                    return option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                return false;
                            }}>
                            {item?.employees.map((value, index) => {
                                return <Option key={`${value.id}`} value={index}>{value.title}</Option>
                            })}
                        </Select>
                    )}
                </div>
            </FormItem>}

            <div style={{ maxWidth: 245, whiteSpace: 'nowrap', marginLeft: 10, display: 'inline-block' }} >
                <FormItem data-tut="reactour__navegateReport2" style={{ maxWidth: 125, display: 'inline-block', marginTop: -1 }} >
                    {this.props.getFieldDecorator(nameof<EmployeeReportRequest>('from'), {
                        rules: [{ required: true, message: t('Initial date must be specified') }, { validator: this.validateDatePickerStart }],
                        initialValue: moment().startOf('month')
                    })(
                        <DatePicker
                            format='DD-MM-YYYY'

                        />
                    )}
                </FormItem>
                <FormItem data-tut="reactour__navegateReport3" style={{ maxWidth: 125, display: 'inline-block', marginTop: -1, marginLeft: -10 }}  >
                    {this.props.getFieldDecorator(nameof<EmployeeReportRequest>('to'), {
                        rules: [{ required: true, message: t('Final date must be specified') }, { validator: this.validateDatePickerEnd }],
                        initialValue: moment().endOf('month')
                    })(
                        <DatePicker
                            format='DD-MM-YYYY'
                        />
                    )}
                </FormItem>
            </div>

            <FormItem >
                <div data-tut="reactour__navegateReport4" style={{ marginLeft: 20, marginTop: -2 }}  >
                    <Button
                        onClick={() => { if (this.props.onSave) { this.props.onSave(); } }}
                        style={{ paddingRight: 11, paddingLeft: 10 }}>
                        <Icon type='eye' />
                        {t('View report')}
                    </Button>
                </div>
            </FormItem>
        </Form>
    }
}

// tslint:disable-next-line:no-empty-interface
export type EmployeesReportViewProps = {
    isAdmin: boolean;
    isManager: boolean;
    companyId: string;
}

@connect(['employees', ReportEmployeesStore], ["employeesReport", EmployeesReportStore])
class EmployeesReportDashboard extends React.Component<EmployeesReportViewProps & WithTranslation & FormComponentProps, EmployeesReportViewState> {
    private get employeesStore() {
        return (this.props as any).employees as ReportEmployeesStore;
    }
    private get employeesReportStore() {
        return (this.props as any).employeesReport as EmployeesReportStore;
    }

    constructor(props: EmployeesReportViewProps & WithTranslation & FormComponentProps) {
        super(props);
        this.state = {
            employeesQuery: {
                searchQuery: '',
                orderBy: [{ field: 'name', direction: 'Ascending', useProfile: false }],
                skip: 0,
                take: 1000
            },
            timesheetsQuery: {
                searchQuery: '',
                orderBy: [{ field: 'fromDate', direction: 'Ascending', useProfile: true }],
                skip: 0,
                take: 1000
            },
            isBusy: false,
            isPlotting: false,
            employees: [],
            employeesIndex: new Map(),
            selectedEmployees: [],
            dataColors: [],
            lineColors: [],
            fromDateStamp: 0,
            toDateStamp: 0,
            chartRenderToggle: false
        };
    }

    componentWillMount() {
        this.loadEmployees(this.state.employeesQuery)
    }

    componentDidUpdate(prevProps: EmployeesReportViewProps) {
        if (this.props.isManager !== prevProps.isManager || this.props.isAdmin !== this.props.isAdmin) {
          this.loadEmployees(this.state.employeesQuery)
        }
      }

    @autobind
    private loadEmployees(query: Query) {
        console.log("test select:");
        console.log("IsManager:", this.props.isManager)
        console.log("IsAdmin", this.props.isAdmin)
        if (this.props.isAdmin || this.props.isManager) {
            var employeesIndex = new Map<string, number>()
            this.setState({ isBusy: true });
            this.employeesStore.changeAdminUrl(this.props.companyId)
            this.employeesStore.getAllAsync(query).then(result => {
                let employees = result.items as EmployeeSummary[]
                employees.forEach((value, index) => { employeesIndex.set((value.id as any) as string, index) })
                this.setState({
                    isBusy: false,
                    employees: employees,
                    employeesIndex: employeesIndex
                });
            }).catch(error => {
                this.setState({ error: formatMessage(error), isBusy: false })
            });
        }
    }

    @autobind
    private onCreateNewItem() {
        const { isAdmin, form } = this.props;
        const { employees } = this.state;

        return new Promise((resolve, reject) => {
            this.props.form.validateFields(event => {
                var values = form.getFieldsValue();
                if (!event) {
                    let fromDateStamp = (values.from as Moment).startOf("day").unix();
                    let toDateStamp = (values.to as Moment).endOf("day").unix();
                    let queryTimesheets = {
                        ...this.state.timesheetsQuery,
                        parameters: {
                            'queryFromDateStamp': (values.from as Moment).clone().startOf("isoWeek").startOf("day").unix(),
                            'queryToDateStamp': (values.to as Moment).clone().endOf("isoWeek").endOf("day").unix(),
                            'fromDateStamp': fromDateStamp,
                            'toDateStamp': toDateStamp,
                            'employeeIds': isAdmin ? values.employees.map((index: number) => employees[index].id) : undefined
                        }
                    };
                    this.setState({
                        timesheetsQuery: queryTimesheets,
                        fromDateStamp: fromDateStamp,
                        toDateStamp: toDateStamp,
                        selectedEmployees: isAdmin ? [...values.employees] : [],
                    });

                    this.loadEmployeesReport(queryTimesheets)
                }
            });
        })
    }

    @autobind
    private async loadEmployeesReport(queryTimesheets: Query) {
        const { isAdmin } = this.props
        this.setState({
            isBusy: true,
            isPlotting: false
        })

        if (isAdmin) this.employeesReportStore.changeAdminUrlByCompany(this.props.companyId);
        else this.employeesReportStore.changeUserUrlByCompany(this.props.companyId);

        await this.employeesReportStore.getAsync(queryTimesheets, { export: false }).then(result => {
            let employeesReport = result.data
            employeesReport.projectIdToName = new Map(Object.entries(employeesReport.projectIdToName).toArray())
            employeesReport.projectTaskIdToName = new Map(Object.entries(employeesReport.projectTaskIdToName).toArray())
            employeesReport.reports.forEach(report => {
                report.workedHoursPerProject = new Map(Object.entries(report.workedHoursPerProject).toArray())
                report.workedHoursPerProjectByMonth = new Map(Object.entries(report.workedHoursPerProjectByMonth).toArray())
                report.workedHoursPerTask = new Map(Object.entries(report.workedHoursPerTask).toArray())
                report.workedHoursPerTaskByMonth = new Map(Object.entries(report.workedHoursPerTaskByMonth).toArray())
            })
            this.setState({
                employeesReport: employeesReport,
                isBusy: false,
                isPlotting: (employeesReport.reports.length > 0),
                dataColors: GetColors(employeesReport.reports.length),
                lineColors: GetColors(Array.from(employeesReport.projectIdToName).length),

            });
        }).catch(error => {
            this.setState({ error: formatMessage(error), isBusy: false })
            return
        })
    }

    @autobind
    private async onDownload(format: string): Promise<boolean> {
        const { isAdmin } = this.props;
        try {
            this.setState({ isBusy: true });
            var values = this.props.form.getFieldsValue()
            let queryTimesheets = {
                ...this.state.timesheetsQuery,
                parameters: {
                    'fromDateStamp': this.state.fromDateStamp,
                    'toDateStamp': this.state.toDateStamp,
                    'queryFromDateStamp': (values.from as Moment).clone().startOf("isoWeek").startOf("day").unix(),
                    'queryToDateStamp': (values.to as Moment).clone().endOf("isoWeek").endOf("day").unix(),
                }
            } as any;

            if (isAdmin) {
                queryTimesheets.parameters.employeeIds = this.state.selectedEmployees.map(index => {
                    return this.state.employees[index].id
                });
                this.employeesReportStore.changeAdminUrlByCompany(this.props.companyId);
            }
            else this.employeesReportStore.changeUserUrlByCompany(this.props.companyId);

            await this.employeesReportStore.getAsync(queryTimesheets, { responseType: 'arraybuffer', export: true, format: format });
            successNotification(this.props.t('Operation Completed Successfully'), this.props.t('Your operation will be processed in background.'));

            this.setState({ isBusy: false });
            return true;
        } catch (error) {
            this.setState({ isBusy: false, error: formatMessage(error) });
            return false;
        }
    }

    public render() {
        const { t, isAdmin, isManager } = this.props;
        const { getFieldDecorator, getFieldValue, validateFields } = this.props.form;

        let reportRequest: EmployeeReportRequest = {
            employees: this.state.employees,
            fromDateStamp: this.state.fromDateStamp,
            toDateStamp: this.state.toDateStamp,
            from: moment(),
            to: moment()
        }
        return <div>
            <Spin size='large' spinning={this.state.isBusy}>
                <Row align='top' justify='space-between'>
                    {this.state.error && <Alert type='error' message={this.state.error} />}
                    <div style={{ top: 0, backgroundColor: 'white', zIndex: 100 }}>
                        <ReportFormBody
                            i18n={this.props.i18n}
                            t={this.props.t}
                            tReady={this.props.tReady}
                            item={reportRequest}
                            getFieldDecorator={getFieldDecorator}
                            getFieldValue={getFieldValue}
                            validateFields={validateFields}
                            onSave={this.onCreateNewItem}
                            isAdmin={isAdmin}
                            isManager={isManager }
                        />
                        {this.state.isPlotting &&
                            <React.Fragment>
                                <div style={{ marginTop: 20, width: "100%" }}>
                                    <EmployeeReportTable
                                        data={this.state.employeesReport as EmployeesReport}
                                        colors={this.state.dataColors}
                                        onDownload={this.onDownload} />
                                </div>
                                <div style={{ marginTop: 20, width: "100%" }}>
                                    <EmployeeReportChart
                                        data={this.state.employeesReport as EmployeesReport}
                                        colors={this.state.dataColors}
                                        colorsForPojects={this.state.lineColors}
                                        renderToggle={this.state.chartRenderToggle}
                                        showBar={true}
                                        showPie={true} />
                                </div>
                            </React.Fragment>}
                        {!this.state.isPlotting && <Empty />}
                    </div>
                </Row>
            </Spin>
        </div>
    }
}

// Wire up the React component to the Redux store
export default withTranslation()(Form.create({})(EmployeesReportDashboard as any) as any) as any as React.ComponentClass<EmployeesReportViewProps>;